import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { INSTAGRAM_FEED } from '../content-types';
import { trackContainerClick } from '../analytics';
import InstagramIcon from '@tradera/blueprint/theme/icons/instagram.svg?jsx';
import ImageIcon from '@tradera/blueprint/theme/icons2/image.svg?jsx';
import './instagram-feed.scss';

const InstagramFeed = ({ data }) => {
    const { title, ids } = data;
    return (
        <section className="instagram-feed px-0 px-md-2 pt-5">
            <h3 className="col-12 text-styled px-3 px-md-2 mb-4">{title}</h3>
            <div className="d-flex flex-wrap flex-lg-nowrap">
                {ids &&
                    ids.map((postId, index) => (
                        <InstagramImage postId={postId} key={postId + index} />
                    ))}
            </div>
        </section>
    );
};

const InstagramImage = ({ postId }) => {
    const [imageAvailable, setImageAvailable] = useState(true);

    return (
        <div className="instagram-feed__post">
            <a
                aria-label="Instagram post"
                className="instagram-feed__image d-block"
                href={`https://www.instagram.com/p/${postId}`}
                target="_blank"
                onClick={() =>
                    trackContainerClick(INSTAGRAM_FEED, 'Instagram post')
                }
                rel="nofollow noopener noreferrer">
                <LazyLoad offset={100} once>
                    {imageAvailable ? (
                        <img
                            className="p-2 p-lg-3"
                            src={`https://www.instagram.com/p/${postId}/media/?size=m`}
                            alt="Instagram post image"
                            onError={() => setImageAvailable(false)}
                        />
                    ) : (
                        <div className="fallback-image p-2 p-lg-3">
                            <div className="w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200">
                                <ImageIcon
                                    style={{ width: '8rem', height: '8rem' }}
                                    className="icon icon-gray-300"
                                />
                            </div>
                        </div>
                    )}
                    <InstagramIcon className="instagram-feed__icon icon icon-lg icon-white position-absolute mr-2 mt-2" />
                </LazyLoad>
            </a>
        </div>
    );
};

InstagramFeed.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string,
        ids: PropTypes.array.isRequired
    }).isRequired
};

export default InstagramFeed;
